export const environment = {
  production: false,
  errorMessage: 'Ha ocurrido un error.\nSi el problema persiste favor de contactar a soporte.',
  //local
  // urlService: 'http://localhost/EstacionesTVAService/ETVAService.svc/',
  //dev
  // urlService: 'https://dev-ada-auditoria.com/ServiceSitiosTelecom/ETVAService.svc/',
  //prod
  urlService: 'https://auditoria.auditoriags.com/EstacionesTVAService/ETVAService.svc/', 
  //test
  // urlService: 'https://auditoria.auditoriags.com/ServiceEstacionesTVATest/ETVAService.svc/',
};
